import usePrevious from './usePrevious';

export default function useChangeDetection(value) {
   const previousValue = usePrevious(value);
   return previousValue !== value;
}
